module.exports = __webpack_public_path__ + "img/user-pilot.3f3f51db.svg";